export const checkDashboardFetching = ({ dashboard: { fetchingData } }) => fetchingData;

export const getDashboardData = ({ dashboard: { data } }) => data;
